import TabsComponent from 'components/tabsComponent';
import Header from 'components/kurort/header';
import ReviewsSlider from 'components/reviews-slider';
import SelectionsSlider from 'components/selections-slider';
import Place from 'components/place';
import {
    checkFavoriteList,
    addTrigger,
    subscribeEvent,
    jsDots,
    lazyLoad,
    updateHotelViewObserver,
} from 'methods/utils';
import metrikaCollector, {collectRetail} from 'components/metrika';

const header = new Header(document.querySelector('.js-header'), {
    fixed: true,
    search: true,
});
document.querySelectorAll('.js-popularResorts').forEach($element => {
    const $button = $element.querySelector('.js-popularResortsButton');

    if ($button) {
        $button.addEventListener('click', () => {
            if ($button.classList.contains('loading')) return;

            const $list = $element.querySelectorAll('.Popular__resort.is-hidden');
            const headerHeight = document.querySelector('.js-headerWrapper')?.offsetHeight || 88;
            const offset = headerHeight + 24;
            const elementPosition = $element.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - offset;

            if ($list.length === 0) {
                $button.innerText = 'Смотреть больше';
                [...$element.querySelectorAll('.Popular__resort')].slice(6).forEach($item => $item.classList.add('is-hidden'));

                window.scrollTo({top: offsetPosition, behavior: 'instant'});
            } else {
                $button.classList.add('loading');
                setTimeout(() => {
                    [...$list].slice(0, 6).forEach($item => $item.classList.remove('is-hidden'));
                    $button.innerText = $element.querySelectorAll('.Popular__resort.is-hidden').length === 0 ? 'Скрыть всё' : 'Смотреть больше';
                    $button.classList.remove('loading');
                }, 250);
            }
        });
    }
});
document.querySelectorAll('.js-place').forEach($element => new Place($element));
document.querySelectorAll('.js-reviewsSlider').forEach($element => new ReviewsSlider($element));
document.querySelectorAll('.js-selections-slider').forEach($element => new SelectionsSlider($element));

new TabsComponent({
    'container': '.Resorts',
    'navigation': '.Resorts__tab',
    'item': '.Resorts__content',
});

checkFavoriteList();

if (window.pageData['retail-rocket']['geo-id']) {
    const geoId = Number(window.pageData['retail-rocket']['geo-id']);
    (window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(function() {
        try { rrApi.categoryView(geoId); } catch(e) {}
        collectRetail(metrikaCollector, 'categoryView', {data: {geoId}});
    });
}
